
<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions" />
</template>

<script>
import { mapState } from 'vuex'
import ColumnsMixin from '../mixins/columns'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'ReportProjectList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'projectrecords',
      }),
      groupActions: [
        {
          label: '新建',
          action: () => {
            this.createDialog('createReportProjectDialog', {
              onManager: this.onManager,
              refresh: this.refresh,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
      ],
    }
  },
  computed: {
    ...mapState('app', {
      cities: state => state.cities,
    }),
  },
  created () {
    this.list.fetchData()
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/less/index';
  .status-success {
    color: @success-color;
  }
  .status-danger {
    color: @error-color;
  }
  .status-info {
    color: @normal-color;
  }
</style>
